import { addDays } from "date-fns";

import { formatDateWithoutParsing } from "../../../shared/utility";

type BestBeforeDateInput = {
  shelfLife: string | number | null | undefined;
  productionDate: string | Date | null | undefined;
  packagingDate: string | Date | null | undefined;
  fromPackaging: boolean;
};

export function computeBestBeforeDate({
  shelfLife,
  productionDate,
  packagingDate,
  fromPackaging,
}: BestBeforeDateInput): string | null {
  const baseDate = fromPackaging ? packagingDate : productionDate;
  const shelfLifeDays = Number(shelfLife);

  if (
    shelfLife === null ||
    shelfLife === undefined ||
    shelfLife === "" ||
    !baseDate ||
    !Number.isFinite(shelfLifeDays)
  ) {
    return null;
  }

  const parsedBaseDate = new Date(baseDate);
  if (Number.isNaN(parsedBaseDate.getTime())) {
    return null;
  }

  return formatDateWithoutParsing(addDays(parsedBaseDate, shelfLifeDays));
}
